module.exports = __webpack_public_path__ + "static/img/2.35d38896.png";